import { z } from 'zod';
import { nullableArray, nullableOptional } from '@shigo-ui/api-client';

export enum StitcherAccessFilter {
  Granted = 'GRANTED',
  All = 'ALL',
}

export const stitcherAccessPageSizes = [10, 25, 50, 100] as const;

const dateValueSchema = z.union([z.string(), z.number()]);

export const stitcherAccessNetworkSchema = z.looseObject({
  id: z.number(),
  name: z.string(),
  roles: nullableArray(z.string()),
});

export const stitcherAccessUserSchema = z.looseObject({
  id: z.string(),
  username: nullableOptional(z.string()),
  email: nullableOptional(z.string()),
  name: nullableOptional(z.string()),
  networks: nullableArray(stitcherAccessNetworkSchema),
  roles: nullableArray(z.string()),
  useStitcher: z.boolean(),
  stitcherGrantedOn: nullableOptional(dateValueSchema),
  stitcherLastUsedOn: nullableOptional(dateValueSchema),
});

export const stitcherAccessPageSchema = z.looseObject({
  content: z.array(stitcherAccessUserSchema),
  totalElements: z.number().int().nonnegative(),
});

export type StitcherAccessUser = z.infer<typeof stitcherAccessUserSchema>;
export type StitcherAccessUserPage = z.infer<typeof stitcherAccessPageSchema>;

export interface StitcherAccessFilterValue {
  searchTerm: string;
  access: StitcherAccessFilter;
  page: number;
  size: number;
}

export const defaultStitcherAccessFilter: StitcherAccessFilterValue = {
  searchTerm: '',
  access: StitcherAccessFilter.Granted,
  page: 0,
  size: 25,
};
